import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserEntity } from '../_models/userEntity';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserEntityService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getAll(memberId: string) {
    return this.http.get<UserEntity[]>(`${environment.apiUrl}/eu?memberId=${memberId}`, { headers: this.authService.headers });
  }

  getEu(euId: string) {
    return this.http.get<UserEntity>(`${environment.apiUrl}/eu/${euId}`, { headers: this.authService.headers });
  }

  deleteEu(euId: string) {
    return this.http.delete(`${environment.apiUrl}/eu/${euId}`, { headers: this.authService.headers });
  }

  addEu(eu: UserEntity) {
    return this.http.post<UserEntity>(`${environment.apiUrl}/eu`, eu, { headers: this.authService.headers });
  }

  updateEu(eu: UserEntity) {
    return this.http.put<UserEntity>(`${environment.apiUrl}/eu/${eu?.euId}`, eu, { headers: this.authService.headers });
  }

  fusionEu(newEu: any) {
    return this.http.post<UserEntity[]>(`${environment.apiUrl}/eu/fusion`, newEu, { headers: this.authService.headers }).toPromise();
  }
}
